<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">

      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Distribution List</a>
        </li>
      </ol>
    </div>
  </div>

  <div class="modal fade" bsModal #addListModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ADD LIST</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addListModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row" *ngIf="newDistributionList">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>List Name</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="newDistributionList.listName" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>From Name</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="newDistributionList.fromName" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>From Email</label>
                <div class="input-group m-b">
                    <input type="email" [(ngModel)]="newDistributionList.fromEmail" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>From SMS Number</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="newDistributionList.fromSmsNumber" class="form-control" maxlength="10"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="addListModal.hide()" class="btn btn-white">Cancel</button>
          <button (click)="addListSave();addListModal.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" bsModal #editListModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">EDIT LIST</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="editListModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row" *ngIf="distributionList">
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>List Name</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="distributionList.listName" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>From Name</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="distributionList.fromName" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>From Email</label>
                <div class="input-group m-b">
                    <input type="email" [(ngModel)]="distributionList.fromEmail"  email="true" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>From SMS Number</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="distributionList.fromSmsNumber" class="form-control"  maxlength="10"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group input-group-sm">
                <label>Default Message Template</label>
                <div class="input-group m-b">
                  <select [(ngModel)]="distributionList.defaultMessageTemplateId" class="form-control form-select">
                    <option value="">None</option>
                    <option *ngFor="let template of remoteTemplate | async" [value]="template.messageTemplateId">{{template.templateName}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="card mt-2">
            <div class="card-body">
              <div class="d-flex fw-bold small mb-3">
                <span class="flex-grow-1">
                  <button (click)="addAddress()" class="btn btn-outline-default"><i class="fa fa-user-plus"></i> Add New Contact</button>
                  <button (click)="downloadAddresses()" class="btn btn-outline-default ml-2"><i class="fa fa-download"></i> Download Contacts</button>
                  <button (click)="startUploadAddresses()" class="btn btn-outline-default ml-2"><i class="fa fa-upload"></i> Upload Contacts</button>
                </span>
              </div>
              <div *ngIf="uploadingAddresses">
                <div class="row">
                  <div class="col-lg-6">
                      <div class="form-group input-group-sm">
                          <label>Contacts CSV File</label>
                          <div class="input-group m-b">
                              <input type="file" #fileInput class="form-control" id="file" (change)="importContacts($event.target.files)" accept=".csv">
                          </div>
                      </div>
                  </div>            
                  <div class="col-lg-6">
                      <div class="alert alert-primary" *ngIf="(importValidation && importValidation.length == 0 && importEvents.length == 0)">
                          <h3 class="h3">Address Import Process</h3>
                          <p>The import process takes a properly formated CSV files.</p>
                          <p>If the <span class="code">DistributionListItemId</span> is found, then that Contact will be updated.</p>
                          <p>If the <span class="code">DistributionListItemId</span> is not found, then that Contact will be added.</p>
                          <p>If a contact has not been updated, then it will be removed.</p>
                      </div>
                      <div class="alert alert-danger" *ngIf="importValidation && importValidation.length > 0 && !importValidated">
                        <h3 class="h3">Import Validation FAILED</h3>
                        <p *ngFor="let v of importValidation">{{v}}</p>
                      </div>
                      <div class="alert alert-success" *ngIf="importValidation && importValidation.length > 0 && importValidated">
                        <h3 class="h3">Import Validation</h3>
                        <p *ngFor="let v of importValidation">{{v}}</p>
                        <button class="btn btn-danger mt-2" (click)="executeImport()">Execute Import</button>
                      </div>
                      <div class="alert alert-success" *ngIf="importEvents && importEvents.length > 0">
                        <h3 class="h3">Import Result</h3>
                        <p *ngFor="let v of importEvents">{{v}}</p>
                      </div>
                  </div>
                </div>
              </div>
              <table class="table table-striped" *ngIf="!uploadingAddresses"> 
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Contact Name</th>
                    <th scope="col">Email Address</th>
                    <th scope="col">Mobile Number</th>
                    <th scope="col">Notification Type</th>
                    <th scope="col">Enabled</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="service.loadingItems">
                    <td colspan="6"><div class="spinner-border"></div></td>
                  </tr>
                  <tr *ngIf="newListItem">
                    <td></td>
                    <td>
                      <input type="text" [ngClass]="{'is-invalid': newListItem.contactName == null, 'is-valid': newListItem.contactName != null}"  class="is-invalid form-control" [(ngModel)]="newListItem.contactName">
                    </td>
                    <td>
                      <input type="email" [ngClass]="{'is-invalid': newListItem.emailAddress == null || !validateEmail(newListItem.emailAddress), 'is-valid': newListItem.emailAddress != null && validateEmail(newListItem.emailAddress)}"  class="form-control" [(ngModel)]="newListItem.emailAddress">
                    </td>
                    <td>
                      <input type="phone" [ngClass]="{'is-invalid': newListItem.mobileNumber == null || newListItem.mobileNumber.length > 15, 'is-valid': newListItem.mobileNumber != null && newListItem.mobileNumber.length > 10}"  class="form-control" [(ngModel)]="newListItem.mobileNumber">
                    </td>
                    <td>
                      <select class="form-select" [ngClass]="{'is-invalid': newListItem.addressType == null, 'is-valid': newListItem.addressType != null}" [(ngModel)]="newListItem.addressType">
                        <option value="0">Email</option>
                        <option value="1">SMS</option>
                        <option value="2">Both</option>
                      </select>
                    </td>
                    <td>                      
                      <div class="form-check form-switch">
                        <input type="checkbox" class="form-check-input" id="newEnabled" [(ngModel)]="newListItem.enabled">
                        <label class="form-check-label" for="newEnabled"></label>
                      </div>
                    </td>
                    <td>
                      <a class="btn btn-outline-default ml-2" (click)="saveNewAddress(address)"><i class="fa fa-plus"></i></a>
                    </td>
                  </tr>
                  <tr *ngFor="let address of remoteItemData | async"> 
                    <td>{{address.distributionListItemId}}</td>
                    <td>
                      <span *ngIf="editListItem != address">{{address.contactName}}</span>
                      <input *ngIf="editListItem == address" type="text" [ngClass]="{'is-invalid': editListItem.contactName == null, 'is-valid': editListItem.contactName != null}"  class="is-invalid form-control" [(ngModel)]="editListItem.contactName">
                    </td>
                    <td>
                      <span *ngIf="editListItem != address">{{address.emailAddress}}</span>
                      <input *ngIf="editListItem == address" type="email" [ngClass]="{'is-invalid': editListItem.emailAddress == null || !validateEmail(editListItem.emailAddress), 'is-valid': editListItem.emailAddress != null && validateEmail(editListItem.emailAddress)}"  class="is-invalid form-control" [(ngModel)]="editListItem.emailAddress">
                    </td>
                    <td>
                      <span *ngIf="editListItem != address">{{address.mobileNumber}}</span>
                      <input *ngIf="editListItem == address" type="phone" maxlength="15" [ngClass]="{'is-invalid': editListItem.mobileNumber == null || editListItem.mobileNumber.length != 10, 'is-valid': editListItem.mobileNumber != null && editListItem.mobileNumber.length == 10}"  class="is-invalid form-control" [(ngModel)]="editListItem.mobileNumber">
                    </td>
                    <td>
                      <span *ngIf="editListItem != address">
                        <span *ngIf="address.addressType == '0'">Email</span>
                        <span *ngIf="address.addressType == '1'">SMS</span>
                        <span *ngIf="address.addressType == '2'">Both</span>
                      </span>
                      <select *ngIf="editListItem == address" class="form-select" [ngClass]="{'is-invalid': editListItem.addressType == null, 'is-valid': editListItem.addressType != null}" [(ngModel)]="editListItem.addressType">
                        <option value="0">Email</option>
                        <option value="1">SMS</option>
                        <option value="2">Both</option>
                      </select>
                    </td>
                    <td class="">
                      <span *ngIf="editListItem != address">
                        <i class="fa fa-check ml-20" *ngIf="address.enabled" title="Enabled"></i>
                      </span>
                      <div *ngIf="editListItem == address" class="form-check form-switch">
                        <input type="checkbox" class="form-check-input" id="editEnabled" [(ngModel)]="editListItem.enabled">
                        <label class="form-check-label" for="editEnabled"></label>
                      </div>
                    </td>
                    <td>
                      <!-- enable edit -->
                      <a class="btn btn-outline-default ml-2" *ngIf="editListItem == null" (click)="editAddress(address)"><i class="fa fa-pencil"></i></a>
                      <a class="btn btn-outline-default ml-2" *ngIf="editListItem != null" (click)="saveAddress(address)"><i class="fa fa-save"></i></a>
                      <!-- delete -->
                      <a class="btn btn-outline-danger ml-2" *ngIf="editListItem == null" (click)="deleteAddress(address)"><i class="fa fa-trash"></i></a>
                      <a class="btn btn-outline-danger ml-2" *ngIf="editListItem != null" (click)="cancelAddress(address)"><i class="fa fa-times"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>  
            </div> 
            <div class="card-arrow">
              <div class="card-arrow-top-left"></div>
              <div class="card-arrow-top-right"></div>
              <div class="card-arrow-bottom-left"></div>
              <div class="card-arrow-bottom-right"></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="editListModal.hide();cancelUploadAddresses();" class="btn btn-white">Close</button>
          <button (click)="updateListSave();editListModal.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" bsModal #sendMessageModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">EDIT LIST</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="sendMessageModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-5">
              <div class="form-group input-group-sm">
                <label>Subject (Used if Template Not Applied)</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="subjectToSend" class="form-control"/>
                </div>
              </div>
              <div class="form-group input-group-sm">
                <label>Input Data</label>
                <div class="input-group m-b">
                  <ngx-monaco-editor
                    [(ngModel)]="messageToSend"
                    [options]="{ language: useTemplate ? 'json' : 'html', theme: 'vs-dark', readOnly: false, automaticLayout: true, scrollBeyondLastLine: false, minimap: { enabled: false } }"
                    style="display:block; height:250px;"
                    (ngModelChange)="messageChanged($event)"></ngx-monaco-editor>
                </div>
              </div>
            </div>
            <div class="col-lg-7">
              <div class="card">
                <div class="card-header">
                  <span class="flex-grow-1">Live Render</span>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-check form-switch">
                        <input type="checkbox" class="form-check-input" id="useTemplate" [(ngModel)]="useTemplate">
                        <label class="form-check-label" for="useTemplate">Use Template</label>
                      </div>
                    </div>
                    <div class="col-sm-6" *ngIf="distributionList && useTemplate">
                      <div class="form-group input-group-sm">
                        <label>Message Template</label>
                        <div class="input-group m-b">
                          <select [(ngModel)]="messageTemplateId" class="form-control form-select" (change)="templateChanged($event)">
                            <option value="">None</option>
                            <option *ngFor="let template of remoteTemplate | async" [value]="template.messageTemplateId">{{template.templateName}}</option>
                          </select>
                        </div>
                      </div>
                    </div>                  
                  </div>
                </div>

                <div class="card-body live-render">
                  <label>SMS</label><br/>
                  <span *ngIf="distributionList" [innerHTML]="liveSms"></span>
                  <hr class="opacity-3 my-2 mx-n3">
                  <label>Subject</label><br/>
                  <span *ngIf="distributionList" [innerHTML]="liveSubject"></span>
                  <hr class="opacity-3 my-2 mx-n3">
                  <span *ngIf="distributionList" [innerHTML]="liveRender"></span>
                </div>
                <div class="card-arrow">
                  <div class="card-arrow-top-left"></div>
                  <div class="card-arrow-top-right"></div>
                  <div class="card-arrow-bottom-left"></div>
                  <div class="card-arrow-bottom-right"></div>
                </div>
              </div>    
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="sendMessageModal.hide()" class="btn btn-white">Close</button>
          <button (click)="sendMessage();sendMessageModal.hide()" class="btn btn-white">Send</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-lg" bsModal #historyModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">EVENT HISTORY</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="historyModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-6">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th></th>
                    <th>Event Time</th>
                    <th>SMS Messages</th>
                    <th>Email Messages</th>
                    <th>Failures</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ev of history" (click)="selectEvent(ev)">
                    <td></td>
                    <td>{{ev.auditTime}}</td>
                    <td>{{ev.smsMessagesSent}}</td>
                    <td>{{ev.emailMessagesSent}}</td>
                    <td>{{ev.failures}}</td>
                    <td><i class="fa fa-check" *ngIf="ev == event"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-lg-6">
              <div class="card">
                <div class="card-header">
                  Event Log
                </div>
                <div class="card-body">
<code *ngIf="event"><pre><div>{{event.eventLog}}</div></pre></code>
                </div> 
                <div class="card-arrow">
                  <div class="card-arrow-top-left"></div>
                  <div class="card-arrow-top-right"></div>
                  <div class="card-arrow-bottom-left"></div>
                  <div class="card-arrow-bottom-right"></div>
                </div> 
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="historyModal.hide()" class="btn btn-white">Close</button>
        </div>
      </div>
    </div>
  </div>

  
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-8">
        <div class="card mt-2 bg-emphasis bg-opacity-25">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">
                <button (click)="addList();addListModal.show()" class="btn btn-outline-default">Add New Distribution List</button>
              </span>
            </div>
            <table class="table table-striped"> 
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">List Name</th>
                  <th scope="col">From Name</th>
                  <th scope="col">From Email</th>
                  <th scope="col">From SMS</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="service.loading">
                  <td colspan="6"><div class="spinner-border"></div></td>
                </tr>
                <tr *ngFor="let list of remoteData | async">
                  <td>{{list.distributionListId}}</td>
                  <td>{{list.listName}}</td>    
                  <td>{{list.fromName}}</td>
                  <td>{{list.fromEmail}}</td>
                  <td>{{list.fromSmsNumber}}</td>
                  <td>
                    <!-- edit address list -->
                    <a class="btn btn-outline-default ml-2" (click)="distributionList=list;editAddresses();editListModal.show()"><i class="fa fa-address-book"></i></a>
                    <!-- send emails -->
                    <a class="btn btn-outline-default ml-2" (click)="distributionList=list;messageTemplateId=distributionList.defaultMessageTemplateId;sendMessageModal.show()"><i class="fa fa-envelope-open"></i></a>
                    <!-- get history -->
                    <a class="btn btn-outline-default ml-2" (click)="distributionList=list;getHistory();historyModal.show();"><i class="fa fa-list"></i></a>
                    <!-- delete -->
                    <a class="btn btn-outline-danger ml-2" (click)="removeRow(list)"><i class="fa fa-trash"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <app-message-template></app-message-template>
      </div>
    </div>
  </div>  
